<template>
  <div class="rd-tools rcp-tools">
    <ui-segment :value="ctl.view" :options="viewOptions" :label="$t('view')" @input="ctl.setView" />

    <template v-if="ctl.currentKey === 'meals'">
      <span class="rcp-tools__label">{{ $t("recipes_shell.order") }}</span>
      <ui-segment :value="ctl.cardOrder" :options="orderOptions" :label="$t('recipes_shell.order_meals')" @input="ctl.setCardOrder" />
      <button v-if="ctl.cardEntries.length" type="button" class="ui-btn ui-btn--ghost ui-btn--sm" @click="ctl.toggleAllCards">
        <v-icon size="16">{{ ctl.allCardsClosed ? "mdi-chevron-down" : "mdi-chevron-up" }}</v-icon>
        {{ ctl.allCardsClosed ? $t("recipes_shell.expand_all") : $t("recipes_shell.collapse_all") }}
      </button>
    </template>

    <span class="rd-tools__spacer"></span>

    <ui-toggle role="switch" :aria-checked="String(ctl.price)" :pressed="ctl.price" @click="ctl.togglePrice">
      <v-icon size="16">mdi-cash-multiple</v-icon>
      {{ $t("recipes_shell.prices") }}
    </ui-toggle>
  </div>
</template>

<script>
const VIEWS = ["meal", "group"];
const ORDERS = ["name", "portions"];

/** Red alatki iznad sadržaja: prikaz (Jela u obrocima / iz grupa), redoslijed kartica, sklapanje svih i cijene. */
export default {
  name: "RecipesTools",
  inject: { ctl: "recipesCtl" },
  data: () => ({ views: VIEWS, orders: ORDERS }),
  computed: {
    viewOptions() {
      return this.views.map((view) => ({ value: view, label: this.ctl.viewLabel(view), disabled: this.ctl.busy }));
    },
    orderOptions() {
      return this.orders.map((order) => ({ value: order, label: this.$t(`recipes_shell.orders.${order}`) }));
    },
  },
};
</script>
